import { z } from "zod";

// Esquema para Endereço
const enderecoSchema = z.object({
  cep: z
    .string({ required_error: "CEP é obrigatório!" })
    .min(1, { message: "O CEP é obrigatório!" })
    .regex(/^\d{5}-\d{3}$/, {
      message: "CEP inválido, formato esperado: XXXXX-XXX!",
    }),
  estado: z
    .string()
    .min(1, { message: "O estado é obrigatório!" })
    .max(2, { message: "Informe a sigla do estado, por exemplo, SP!" }),
  cidade: z.string().min(1, { message: "A cidade é obrigatória!" }),
  bairro: z.string().min(1, { message: "O bairro é obrigatório!" }),
  numero: z
    .string()
    .min(1, { message: "O número é obrigatório!" })
    .regex(/^\d+$/, { message: "O número deve ser um valor numérico!" }),
  complemento: z.string().optional(),
  logradouro: z.string().min(1, { message: "O logradouro é obrigatório!" }),
});

// Esquema responsavel pela endreço
const deliveryAddress = z.object({
  name_address_delivery: z
    .string()
    .min(1, { message: "O nome do responsável é obrigatório!" })
    .min(3, {
      message: "O nome do responsável deve ter pelo menos 3 caracteres!",
    }),
  email_address_delivery: z
    .string()
    .min(1, { message: "O e-mail do responsável é obrigatório!" })
    .email({ message: "E-mail inválido!" }),
  phone_address_delivery: z
    .string()
    .min(1, {
      message: "O telefone do responsável para contato é obrigatório!",
    })
    .regex(/^\(\d{2}\) \d{4,5}-\d{4}$/, {
      message: "Telefone inválido, formato esperado: (XX) XXXXX-XXXX!",
    }),
  setor_address_delivery: z.string().min(1, { message: "O setor é obrigatório!" }),
});

const enderecoEntrega = z.object({
  cep: z.string().optional(),
  estado: z.string().optional(),
  cidade: z.string().optional(),
  bairro: z.string().optional(),
  numero: z.string().optional(),
  complemento: z.string().optional(),
  logradouro: z.string().optional(),
});

const getFormSchema = () => {
  return z.object({
    endereco: enderecoSchema,
    deliveryAddress: deliveryAddress,
    enderecoEntrega: enderecoEntrega.optional(),
  });
};

// Exportando os esquemas para validação
export { deliveryAddress, enderecoEntrega, enderecoSchema, getFormSchema };
